import analyticsActions, { Actions as BuildingPageAnalyticsActions } from './analyticsActions';

export type Actions = BuildingPageAnalyticsActions;
export default {
  ...analyticsActions,
};
